module.exports = __webpack_public_path__ + "img/paypal-light.812e929d.svg";